export const DesignationLevelEnum = Object.freeze(
  {
     Executive:0,
     Management:1,
     IndividualContributor:2,
  })

  export const DesignaitonEnumLabel = Object.freeze({
    [DesignationLevelEnum.Executive]:"Executive",
    [DesignationLevelEnum.Management]:"Management",
    [DesignationLevelEnum.IndividualContributor]:"Individual Contributor",

  })